module.exports = __webpack_public_path__ + "static/media/pwdhelpscrn.962d28b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pwdhelpscrn.png
// module id = 1157
// module chunks = 0